import { Message, MessageProps } from 'semantic-ui-react';
import React, { FC }             from 'react';

export const EmptyCollectionMessage: FC<MessageProps> = ( props = {} ) => (
	<Message
		className='fade-in'
		size='tiny'
		icon='cube'
		header='There are no items'
		content='Try adding an item to see them in a list.'
		{ ...props }
	/>
);
